import React, { Component } from "react";

const Scrolled = () => {
	
	let scrollTop = false;
	let waypoints = [];
	let currentColor = 'transparent';
	let projectTemplate = false;
	
	function handleResize() {
		waypoints = [];
		if (document.getElementsByClassName('c-pro-template').length > 0) {
			currentColor = null;		
			projectTemplate = true;
		} else {
			for (let i=0;i<document.getElementsByClassName('c-page__block').length;i++) {
				let el = document.getElementsByClassName('c-page__block')[i];
				waypoints[i] 			= [];
				waypoints[i]['offset'] 	= el.offsetTop - document.getElementsByClassName('c-header')[0].clientHeight;
				if (el.classList.contains('c-page__block--transparent')) {
					waypoints[i]['color'] = 'transparent';
				} else if (el.classList.contains('c-page__block--cream')) {
					waypoints[i]['color'] = 'cream';
				} else {
					waypoints[i]['color'] = 'charcoal';
				}
			}
			currentColor = 'transparent';
		}
		handleScroll();
		
	}
	
	function handleScroll(){
		let thisColor = null;
		if (projectTemplate === true) {
			 thisColor = 'charcoal';
		} else {
			if (waypoints) {
				
				for (let i=0;i<waypoints.length;i++) {
					if (waypoints[i]['offset'] < window.scrollY) {
						thisColor = waypoints[i]['color'];
					}
				}
			}
		}
				
		if (currentColor !== thisColor && thisColor !== null) {
			currentColor = thisColor;
			document.body.classList.remove('state-header-transparent');
			document.body.classList.remove('state-header-charcoal');
			document.body.classList.remove('state-header-cream');
			document.body.classList.add('state-header-' + currentColor);
		}
		
		if (window.scrollY < 3 && scrollTop === false) {
			scrollTop = true;
			document.body.classList.add('state-scrolled-top');
		} else if (window.scrollY > 3 && scrollTop === true) {
			scrollTop = false;
			document.body.classList.remove('state-scrolled-top');
		}
		
	}

	window.addEventListener("scroll", (e) => handleScroll(e));
	window.addEventListener("resize", (e) => handleResize(e));

	return (
    	<></>
	);
};

export default Scrolled;